module.exports = "<p>\r\n  page-not-found works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.html
// module id = ./src/app/page-not-found/page-not-found.component.html
// module chunks = main